export default __webpack_public_path__ + "assets/video_placeholder-47574a41f657256e2df201edd808fdab.jpg";